"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NamespacedName {
    constructor(namespace, name) {
        this.namespace = namespace;
        this.name = name;
    }
    equals(other) {
        return this.namespace === other.namespace && this.name === other.name;
    }
    toString() {
        return `${this.namespace}#${this.name}`;
    }
}
exports.NamespacedName = NamespacedName;
function namespace(namespace) {
    const f = (name) => {
        return new NamespacedName(namespace, name);
    };
    f.namespace = namespace;
    return f;
}
exports.namespace = namespace;
//# sourceMappingURL=NamespacedNamed.js.map